<template>
  <div>
    <v-container class="rs-controls">
      <v-row>
        <v-col cols="8">
          <v-row dense>
            <v-col cols="3" v-for="(button, index) in buttons" :key="`button-${index}`">
              <SensorButton
                v-model="button.value"
                :conversion="button.conversion"
                :name="button.name"
                :initialValue="button.initialValue"
                @input="onSensorInput(button, button.platformIndex == null ? index : button.platformIndex, $event)"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row dense>
            <v-col cols="4" v-for="(output, index) in outputs" :key="`output-${index}`">
              <Output
                :value="output.value"
                :conversion="output.conversion"
                :name="output.name"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="bridge">
        <!-- <v-col cols="2" >
          Antwortdelay
        </v-col> -->
        <v-col cols="4" >
          <v-text-field
            v-model="bridge.delay"
            label="DELAY (ms Verz. vor Antwort auf Regler-Paket)"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
/*
  js data ---> sendUartData() ---> VBusChannel ---> emit(uartDidTransmit)
*/
import { Bridge } from '@/bridges/Bridge.js';
import SensorButton from '@/components/SensorButton';
import Output from '@/components/Output';
import state from '@/state';

const Connection = require('resol-vbus/src/connection');
const Packet = require('resol-vbus/src/packet');

class EmBridge extends Bridge {
  constructor(options) {
    super();
    this.vbusAddress = options.vbusAddress;
    this.buttons = options.buttons;
    this.outputs = options.outputs;
    this.relaisStates = [];
    this.delay = 50;
    for (let i = 0; i < this.outputs.length; i += 1) {
      this.relaisStates.push({
        time1: 1,
        value1: 0,
        time2: 0,
        value2: 0,
      });
    }
    this.connection = new Connection();
    this.connection.on('packet', this.handlePacket.bind(this));
  }

  sendUartData(index, rxBuffer) {
    if (index === 0) {
      this.connection.write(rxBuffer);
    }
  }

  handlePacket(packet) {
    if (packet.destinationAddress !== this.vbusAddress) {
      return;
    }
    if (packet.command !== 0x0200) {
      return;
    }
    for (let i = 0; i < this.outputs.length; i += 1) {
      const baseOffset = i * 8;
      const value1 = packet.frameData.readUInt8(baseOffset + 0) * 1000;
      const time1 = packet.frameData.readUIntLE(baseOffset + 1, 3);
      const value2 = packet.frameData.readUInt8(baseOffset + 4) * 1000;
      const time2 = packet.frameData.readUIntLE(baseOffset + 5, 3);

      // value1 für timer1 sekunden, value2 für timer2 sekunden, value1 für timer1 sekunden.... 
      this.relaisStates[i].value1 = value1;
      this.relaisStates[i].time1 = time1;
      this.relaisStates[i].value2 = value2;
      this.relaisStates[i].time2 = time2;
    }
    const txFrameData = Buffer.alloc(24);

    for (let i = 0; i < this.buttons.length; i += 1) {
      txFrameData.writeUInt32LE(this.buttons[i].value.value | 0, i * 4);
    }

    const txPacket = new Packet({
      destinationAddress: packet.sourceAddress,
      sourceAddress: packet.destinationAddress,
      command: 0x0100,
      frameCount: 6,
      frameData: txFrameData,
    });

    state.setTimeout(() => {
      const txBuffer = txPacket.toLiveBuffer();
      for (let i = 0; i < txBuffer.length; i += 1) {
        this.emit('uartDidTransmit', 0, txBuffer[i]);
      }
    }, +this.delay);
  }
}

export default {
  props: [
    'vbusAddress',
  ],

  components: {
    SensorButton,
    Output,
  },

  data: () => ({
    bridge: null,
    intervalId: 0,
    relaisState: [],

    buttons: [
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 70.3, name: 'S1', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 35.3, name: 'S2', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 20.3, name: 'S3', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 50.3, name: 'S4', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 60.3, name: 'S5', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 72.3, name: 'S6', },
    ],
    outputs: [
      { name: 'R1', conversion: 'dutycyclePercent', value: null },
      { name: 'R2', conversion: 'dutycyclePercent', value: null },
      { name: 'R3', conversion: 'dutycyclePercent', value: null },
      { name: 'R4', conversion: 'dutycyclePercent', value: null },
      { name: 'R5', conversion: 'dutycyclePercent', value: null },
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', label: 'GP' },
    ],
  }),

  methods: {
    async prepareDevice() {
      this.bridge = new EmBridge({
        vbusAddress: this.vbusAddress,
        buttons: this.buttons,
        outputs: this.outputs,
      });
      this.intervalId = state.setInterval(this.intervalHandler.bind(this), 1000);
    },

    startDevice() {},

    restartDevice() {},

    onSensorInput(/*button, index, value*/) {},

    intervalHandler() {
      for (let i = 0; i < this.outputs.length; i += 1) {
        const relaisState = this.bridge.relaisStates[i];
        if (!relaisState) {
          continue;
        }
        const output = this.outputs[i];
        if (!output.timer) {
          output.timer = 0;
        }
        const totalTime = relaisState.time1 + relaisState.time2;
        if (output.timer >= totalTime) {
          output.timer = 0;
        }
        if (output.timer < relaisState.time1) {
          output.value = { value: relaisState.value1 };
        } else {
          output.value = { value: relaisState.value2 };
        }
        output.timer += 1;
      }
    },
  },
};
</script>

<style>

</style>
